import React from "react";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="relative bg-slate-900 text-white pt-20 pb-10 overflow-hidden">
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 85% 10%, rgba(31,60,136,0.5), transparent 40%), radial-gradient(circle at 10% 90%, rgba(213,32,39,0.25), transparent 40%)",
        }}
      />

      <div className="relative max-w-[1360px] mx-auto px-5 lg:px-10">
        {/* Giant wordmark */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1 }}
          className="font-display tracking-tight leading-none text-[22vw] lg:text-[18vw] text-white/95 border-b border-white/10 pb-6 mb-14"
        >
          ZAM<span className="italic text-[#D52027]">.</span>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" aria-label="ZAM Autoverkstad" className="inline-flex">
              <img
                src="/zam-logo.webp"
                alt="ZAM Autoverkstad"
                className="h-[104px] sm:h-[116px] w-auto object-contain"
              />
            </a>
            <p className="mt-5 text-white/70 max-w-sm leading-relaxed">
              Service, reparation och felsökning med tydlig kontakt från första fråga
              till färdig bil.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="ticker text-slate-400">Navigera</h4>
            <ul className="mt-5 space-y-3">
              {[
                ["#tjanster", "Tjänster"],
                ["#process", "Så fungerar det"],
                ["#boka", "Boka tid"],
                ["#faq", "Vanliga frågor"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a
                    href={h}
                    className="text-white/85 hover:text-white transition-colors text-[1rem]"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="ticker text-slate-400">Kontakt</h4>
            <p className="mt-5 text-white/70 text-[0.95rem] leading-relaxed">
              Bokningsformuläret är snabbaste vägen in. Berätta vad bilen behöver så
              tar ZAM kontakten vidare därifrån.
            </p>
            
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-white/50 text-[0.8rem]">
            © {new Date().getFullYear()} ZAM Autoverkstad — alla rättigheter
            förbehållna. Konceptdemo framtagen inför fortsatt utveckling.
          </p>
          <p className="text-white/50 text-[0.8rem]">
            Webbkoncept av Elido.
          </p>
        </div>
      </div>
    </footer>
  );
}
